// const AUTOPLAY_SPEED = 5000;

//   $(document).ready(function () {
//     const $slider = $('.heroSlider');

//     document.documentElement.style.setProperty('--slide-duration', AUTOPLAY_SPEED + 'ms');

//     $slider.slick({
//       dots: true,
//       arrows: false,
//       infinite: true,
//       autoplay: true,
//       autoplaySpeed: AUTOPLAY_SPEED,
//       speed: 700,
//       fade: true,
//       cssEase: 'ease-in-out',
//       pauseOnHover: false,
//       customPaging: function (slider, i) {
//         return '<div class="dot">' +
//                  '<span class="dot__base"></span>' +
//                  '<span class="dot__progress"></span>' +
//                '</div>';
//       }
//     });

//     //$slider.on('mouseenter', () => $slider.addClass('paused'));
//     //$slider.on('mouseleave', () => $slider.removeClass('paused'));
//   });

// Default duration for ordinary (non-video) slides.
  const AUTOPLAY_SPEED = 5000; // ms

  $(document).ready(function () {
    const $slider = $('.hero-slider');
    let advanceTimer = null;

    // used only if a video's real length genuinely can't be determined
    // (e.g. the file fails to load) — a generous safety net, not a target
    const FALLBACK_VIDEO_DURATION = 15000;

    function setDotDuration(ms) {
      document.documentElement.style.setProperty('--slide-duration', ms + 'ms');
    }

    function clearAdvanceTimer() {
      if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
    }

    function pauseAllVideos() {
      $slider.find('.hero-slide__video').each(function () {
        this.pause();
        this.currentTime = 0;
      });
    }

    // Resolves with the video's real length in ms, read live from the file.
    // If metadata is already buffered (readyState >= 1, common with
    // preload="auto" since the video has been sitting in the DOM) it
    // resolves instantly; otherwise it waits for 'loadedmetadata'.
    function getVideoDurationMs(video) {
      return new Promise((resolve) => {
        const isReady = video.readyState >= 1 && isFinite(video.duration) && video.duration > 0;
        if (isReady) {
          resolve(video.duration * 1000);
          return;
        }
        const onLoaded = () => {
          cleanup();
          const ok = isFinite(video.duration) && video.duration > 0;
          resolve(ok ? video.duration * 1000 : null);
        };
        const onError = () => { cleanup(); resolve(null); };
        function cleanup() {
          video.removeEventListener('loadedmetadata', onLoaded);
          video.removeEventListener('error', onError);
        }
        video.addEventListener('loadedmetadata', onLoaded);
        video.addEventListener('error', onError);
      });
    }

    // Forces the active dot's progress-fill animation to (re)start cleanly.
    // Needed here specifically because a video's real duration can arrive
    // asynchronously (after the dot already became visible with a
    // placeholder duration) — so we correct it once we know the truth.
    function restartActiveDotAnimation() {
      const $ring = $slider.find('.slick-active .dot__progress');
      $ring.css('animation', 'none');
      void $ring[0]?.offsetWidth;
      $ring.css('animation', '');
    }

    // Called once on load, and again every time Slick finishes changing slide.
    function handleActiveSlide() {
      clearAdvanceTimer();
      pauseAllVideos();

      const idx = $slider.slick('slickCurrentSlide');
      const $active = $slider.find('.hero-slide').eq(idx);
      const isVideo = $active.hasClass('hero-slide--video');
      const video = $active.find('.hero-slide__video')[0];

      if (isVideo && video) {
        // an explicit data-duration always wins, in case you ever want to
        // force a shorter/longer hold than the video's actual length
        const manualOverride = parseInt($active.attr('data-duration'), 10) || null;

        const durationPromise = manualOverride
          ? Promise.resolve(manualOverride)
          : getVideoDurationMs(video);

        durationPromise.then((durationMs) => {
          const finalDuration = durationMs || FALLBACK_VIDEO_DURATION;

          setDotDuration(finalDuration);
          restartActiveDotAnimation(); // correct the ring now that we know the real length

          video.currentTime = 0;
          const playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});

          // primary trigger: advance the instant the video actually ends
          video.addEventListener('ended', function onEnded() {
            video.removeEventListener('ended', onEnded);
            clearAdvanceTimer();
            $slider.slick('slickNext');
          });

          // safety-net trigger, in case 'ended' never fires
          advanceTimer = setTimeout(() => $slider.slick('slickNext'), finalDuration + 800);
        });

      } else {
        // normal image slide — just wait out the standard AUTOPLAY_SPEED
        setDotDuration(AUTOPLAY_SPEED);
        advanceTimer = setTimeout(() => $slider.slick('slickNext'), AUTOPLAY_SPEED);
      }
    }

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: false,   // autoplay is now driven manually so video slides
                          // can run their own full length instead of being
                          // cut off at the default AUTOPLAY_SPEED
      speed: 700,
      fade: true,
      cssEase: 'ease-in-out',
      pauseOnHover: false,
      customPaging: function (slider, i) {
        return '<div class="dot">' +
                 '<span class="dot__base"></span>' +
                 '<span class="dot__progress"></span>' +
               '</div>';
      }
    });

    $slider.on('afterChange', handleActiveSlide);
    handleActiveSlide(); // kick things off for the first slide

    // Optional: pause rotation + video + dot fill on hover.
    // $slider.on('mouseenter', () => {
    //   $slider.addClass('paused');
    //   clearAdvanceTimer();
    //   $slider.find('.hero-slide__video').each(function(){ this.pause(); });
    // });
    // $slider.on('mouseleave', () => {
    //   $slider.removeClass('paused');
    //   handleActiveSlide();
    // });

    var $testimonialSlider = $('.testimonial-slider');
    if (!$testimonialSlider.length || typeof $.fn.slick === 'undefined') { return; }
    $testimonialSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      speed: 500,
      arrows: true,
      dots: true,
      appendArrows: $('.testimonial-nav'),
      appendDots: $('.testimonial-dots'),
      prevArrow: '<button type="button" class="t-arrow t-arrow--prev" aria-label="Previous testimonial"><svg width="46" height="44" viewBox="0 0 46 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45.0986 21.5488H2.91768M22.1653 1.04883L2.09863 21.5488L22.1653 42.0488" stroke="currentcolor" stroke-width="3"/></svg></button>',
      nextArrow:'<button type="button" class="t-arrow t-arrow--next" aria-label="Next testimonial"><svg width="46" height="44" viewBox="0 0 46 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.19209e-06 21.5488H42.181M22.9333 1.04883L43 21.5488L22.9333 42.0488" stroke="currentcolor" stroke-width="3"/></svg></button>',
      // customPaging: function (slider, i) {
      //   return '<button type="button" aria-label="Go to testimonial ' + (i + 1) + '"><span></span></button>';
      // },
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1 } }
      ]
    });
    
  });


  $(function () {
    var $slider = $('.best-sellers-slider');
 
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      speed: 400,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768,  settings: { slidesToShow: 2 } },
        { breakpoint: 480,  settings: { slidesToShow: 1 } }
      ]
    });
 
    // custom arrow buttons — guard against clicks while disabled
    $('.nav-prev').on('click', function () {
      if ($(this).hasClass('is-disabled')) return;
      $slider.slick('slickPrev');
    });
    $('.nav-next').on('click', function () {
      if ($(this).hasClass('is-disabled')) return;
      $slider.slick('slickNext');
    });
 
    // toggle disabled state on edges (class-based, not the native
    // disabled attribute, so state stays predictable across breakpoints)
    function updateArrows(currentSlide) {
      var slidesToShow = $slider.slick('slickGetOption', 'slidesToShow');
      var lastSlide = $slider.slick('getSlick').slideCount - slidesToShow;
 
      $('.nav-prev')
        .toggleClass('is-disabled', currentSlide <= 0)
        .prop('disabled', currentSlide <= 0);
 
      $('.nav-next')
        .toggleClass('is-disabled', currentSlide >= lastSlide)
        .prop('disabled', currentSlide >= lastSlide);
    }
 
    $slider.on('init', function () {
      updateArrows(0);
    });
    $slider.on('afterChange', function (event, slick, currentSlide) {
      updateArrows(currentSlide);
    });
    $slider.on('breakpoint', function () {
      updateArrows($slider.slick('slickCurrentSlide'));
    });
  });


  function inlineSvgImages(selector = 'img.svg-inline') {
  document.querySelectorAll(selector).forEach((img) => {
    const src = img.getAttribute('src');
    if (!src) return;

    fetch(src)
      .then((res) => {
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        return res.text();
      })
      .then((svgMarkup) => {
        const svgEl = new DOMParser()
          .parseFromString(svgMarkup, 'image/svg+xml')
          .querySelector('svg');
        if (!svgEl) return;

        // Strip fixed dimensions so CSS controls sizing
        svgEl.removeAttribute('width');
        svgEl.removeAttribute('height');

        // Carry over class/id so existing CSS/JS selectors keep working
        const extraClasses = (img.getAttribute('class') || '')
          .split(/\s+/)
          .filter((c) => c && c !== 'svg-inline')
          .join(' ');
        svgEl.setAttribute('class', `${extraClasses} svg-inline--converted`.trim());
        if (img.id) svgEl.id = img.id;

        // Preserve accessibility semantics
        const alt = img.getAttribute('alt');
        if (alt) {
          svgEl.setAttribute('role', 'img');
          svgEl.setAttribute('aria-label', alt);
        } else {
          svgEl.setAttribute('aria-hidden', 'true');
        }

        img.replaceWith(svgEl);
      })
      .catch((err) => console.error('inlineSvgImages:', src, err));
  });
}

document.addEventListener('DOMContentLoaded', () => inlineSvgImages());



// Brand Section JS

$(function () {

    var wlPrevArrow = '<button type="button" class="slick-arrow slick-arrow--prev" aria-label="Previous brands">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">' +
      '<rect x="0.75" y="0.75" width="46.5" height="46.5" rx="23.25" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M30.5 24H18.3667M23.5667 17.5L17.5 24L23.5667 30.5" stroke="currentColor" stroke-width="2"/>' +
      '</svg></button>';

    var wlNextArrow = '<button type="button" class="slick-arrow slick-arrow--next" aria-label="Next brands">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">' +
      '<rect x="0.75" y="-0.75" width="46.5" height="46.5" rx="23.25" transform="matrix(-1 0 0 1 48 1.5)" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M17.5 24H29.6333M24.4333 17.5L30.5 24L24.4333 30.5" stroke="currentColor" stroke-width="2"/>' +
      '</svg></button>';

    $('.brands-carousel').slick({
      rows: 3,
      slidesPerRow: 6,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      appendArrows: $('.brands-nav'),
      prevArrow: wlPrevArrow,
      nextArrow: wlNextArrow,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            rows: 3,
            slidesPerRow: 5
          }
        },
        {
          breakpoint: 990,
          settings: {
            rows: 3,
            slidesPerRow: 4
          }
        },
        {
          breakpoint: 750,
          settings: {
            rows: 3,
            slidesPerRow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            rows: 3,
            slidesPerRow: 2
          }
        }
      ]
    });

  });

  // Collection Section JS Start
  $('.collection-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
  });

  // Testimonial Section JS Code Start
  


  // Scroll Sticky Header Section

(function () {
  var promotionBar = document.querySelector('.promotion-bar');
  var headerSection = document.querySelector('.header-section');
  if (!headerSection) return;

  var triggerHeight = promotionBar ? promotionBar.offsetHeight : 0;
  function updateTriggerHeight() {
    triggerHeight = promotionBar ? promotionBar.offsetHeight : 0;
  }

  function toggleSticky() {
    var scrollY = window.scrollY || window.pageYOffset;
    if (scrollY >= triggerHeight) {
      headerSection.classList.add('sticky');
    } else {
      headerSection.classList.remove('sticky');
    }
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        toggleSticky();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateTriggerHeight);
  toggleSticky();
})();